<script>
  import _ from 'lodash'
	import { fade, slide } from 'svelte/transition';
  import FilterItem from './FilterItem.svelte'
  import { decodeCategory } from './utils.js'
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

  export let height

  export let filters;
  let toggledFilters = [];
  $: {
    dispatch('toggle', toggledFilters)
  }

  function toggleFilter(label) {
    if (toggledFilters.includes(label)) toggledFilters = toggledFilters.filter(c => c !== label) 
    else toggledFilters = [...toggledFilters, label]
  }

  function resetFilters() {
    toggledFilters = [];
  }

  function selectAllFilters() {
    toggledFilters = [
      ...filters.map(c => c.name),
      ...filters.map(c => c.children.map(c => c.name)).flat()
    ]
  }

  let hidden = false

</script>

<div class="level" style="max-height:{height}px">
  <div class="level-right">
		<div class="card filter-list" in:fade>
			<nav class="panel">
        <div class="panel-heading">
          <p>Categories</p> 
          <button class="toggle-button" class:hidden aria-label="Toggle filters" on:click={() => hidden = !hidden}>
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 64 80" x="0px" y="0px"><title>down-arrow</title><path d="M5.243 14.938c-0.941 0-1.896 0.366-2.61 1.080-1.429 1.429-1.429 3.792 0 5.221l26.741 26.741c0.69 0.69 1.664 1.080 2.61 1.080 0.937 0 1.871-0.341 2.61-1.080l26.704-26.706c1.496-1.408 1.515-3.827 0.086-5.256s-3.792-1.429-5.221 0c-0 0-0.001 0.001-0.001 0.001v0l-24.131 24.178-24.179-24.179c-0.715-0.715-1.67-1.080-2.61-1.080z"/></svg>
          </button>
        </div>
        {#if !hidden}
          <div class="panel-body" transition:slide>
            <div class="panel-block">
              {#if toggledFilters.length > 0 }
                <button class="button is-link is-outlined is-fullwidth" on:click={resetFilters}>
                  Reset all filters
                </button>
              {:else}
                <button class="button is-link is-fullwidth" on:click={selectAllFilters}>
                  Select all filters
                </button>
              {/if}
            </div>
            {#each filters as filter}
              <FilterItem name={filter.name} checked={toggledFilters.includes(filter.name)} on:check={() => toggleFilter(filter.name)} />
              {#if filter.children.length > 0}
                {#each filter.children as childCat}
                  <FilterItem name={childCat.name} checked={toggledFilters.includes(childCat.name)} on:check={() => toggleFilter(childCat.name)} nested={true}/>
                {/each}
              {/if}
            {:else}
              <h2 class="title is-5">Loading filters</h2>
            {/each}
          </div>
        {/if}
			</nav>
		</div>
  </div>
</div>

<style>
	button.button.is-link {
		margin: 0;
	}
  .toggle-button {
    padding: 0 0.5rem;
    background: transparent;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  .toggle-button svg {
    width: 1rem;
    height: 1rem;
    position: relative;
    transform: scaleY(-1);
    top: -1px;
    transition: transform 0.25s, top 0.25s;
    fill: #3273dc;
  }
  .toggle-button.hidden svg {
    transform: scaleY(1);
    top: 2px;
    transition: transform 0.25s, top 0.25s;
  }
  div.level {
    position: absolute;
    right: 0;
    z-index: 9;
    justify-content: flex-end;
    overflow: scroll;
    align-items: flex-start;
  }
  div.filter-list {
    margin-right: 1rem;
    margin-top: 1rem;
    margin-bottom: 2rem;
    box-shadow: 0 2px 13px 5px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
  }
  .panel {
    width: 18rem;
  }
  :global(.panel-block input[type="checkbox"]) {
    margin: 0;
    margin-right: 0.5rem;
  }
  .panel-heading {
    font-weight: 500;
    display: flex;
    justify-content: space-between;
  }
</style>